export default __webpack_public_path__ + "static/media/admin.15436c65.png";